var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',_vm._g(_vm._b({attrs:{"name":"FadeRight"}},'transition',_vm.$attrs,false),_vm.hooks),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }